import * as React from "react";
import { useField } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FormikFormGroup, Dropzone, Icon } from "components/common";
import { Button } from "components/bootstrap";
const PEM_MIME_TYPES = [
  "application/pkcs8",
  // .key
  "application/pkix-cert",
  // .cer
  "application/x-pem-file",
  // .pem
  "application/x-x509-ca-cert",
  // .crt
  "application/x-x509-user-cert",
  // .crt
  "text/plain"
];
const DropzoneInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const SAMLPEMField = ({
  name,
  filename,
  label,
  help,
  isValueSet,
  children = void 0,
  encrypted = false,
  maxSize = 1024 * 1024,
  disabled = false
}) => {
  const { t } = useTranslation("enterprise_authentication");
  const [, , { setValue: setFilename }] = useField(filename);
  const [, { value }, { setValue }] = useField(name);
  if (isValueSet) {
    return /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        name: filename,
        label,
        help,
        disabled: true,
        buttonAfter: /* @__PURE__ */ React.createElement(
          Button,
          {
            type: "button",
            bsStyle: "danger",
            disabled,
            onClick: () => {
              if (encrypted && (value == null ? void 0 : value.is_set)) {
                setValue({ delete_value: true });
              } else {
                setValue(void 0);
              }
              setFilename(void 0);
            }
          },
          t("saml.saml_pem_field.remove")
        )
      }
    );
  }
  const handleFileDrop = (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      if (encrypted) {
        setValue({ set_value: reader.result.toString() });
      } else {
        setValue(reader.result.toString());
      }
      setFilename(file.name);
    });
    reader.readAsText(file);
  };
  return /* @__PURE__ */ React.createElement(FormikFormGroup, { type: "", name: filename, label, help }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Dropzone, { onDrop: handleFileDrop, accept: PEM_MIME_TYPES, multiple: false, maxSize }, /* @__PURE__ */ React.createElement(DropzoneInner, null, /* @__PURE__ */ React.createElement(Dropzone.Accept, null, /* @__PURE__ */ React.createElement(Icon, { name: "verified_user", type: "regular", size: "sm" }), " ", t("saml.saml_pem_field.pem_accept")), /* @__PURE__ */ React.createElement(Dropzone.Reject, null, /* @__PURE__ */ React.createElement(Icon, { name: "error", type: "regular", size: "sm" }), " ", t("saml.saml_pem_field.pem_reject", { types: PEM_MIME_TYPES.join(", ") })), /* @__PURE__ */ React.createElement(Dropzone.Idle, null, /* @__PURE__ */ React.createElement(Icon, { name: "verified_user", type: "regular", size: "sm" }), " ", children || t("saml.saml_pem_field.idle"))))));
};
export default SAMLPEMField;
